<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardIncidences.title').toUpperCase()"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'DashboardIncidences',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardIncidences.vue